import { FormGroup } from '@angular/forms';

export class AppUtils {
  public static getFormErrors(theForm: FormGroup, formErrors: any): [] {
    for (const field in formErrors) {
      if (!Object.prototype.hasOwnProperty.call(formErrors, field)) {
        continue;
      }

      // Clear previous errors
      formErrors[field] = {};

      // Get the control
      const control = theForm?.get(field);

      if (control && control.dirty && !control.valid) {
        formErrors[field] = control.errors;
      }
    }

    return formErrors;
  }

  // public static getActiveItems(itemList: Array<[]>): Array<[]> {
  //   const onlyActiveItems: [] = [];
  //
  //   itemList.forEach((item: any) => {
  //     if (item.active) {
  //       onlyActiveItems.push(item);
  //     }
  //   });
  //
  //   return onlyActiveItems;
  // }
  //
  // public static getSortOrder(key): any {
  //   switch (key){
  //     case 'ascend':
  //       return 1;
  //     case 'descend':
  //       return -1;
  //     default:
  //       return -1;
  //   }
  // }
  //
  // public static getSortOrderOfLiveOrders(key): any {
  //   switch (key){
  //     case 'ascend':
  //       return 1;
  //     case 'descend':
  //       return -1;
  //     default:
  //       return 1;
  //   }
  // }
}
